import type { CarouselItem, CarouselItemTyped } from '@setplex/tria-api'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { VodWithPrice } from '~/shared/interfaces'

import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const formatFeaturedRowVods = (
  items: CarouselItem[],
  adjust: AdjustPurchaseableFn
): CarouselItemTyped<VodWithPrice>[] => {
  return items.map((item: CarouselItem): CarouselItemTyped<VodWithPrice> => {
    return {
      ...item,
      vod:
        item.vod &&
        (extendMediaItemByLabelPrice(adjust(item.vod)) as VodWithPrice),
    }
  })
}
